import React, { ReactNode, Ref } from "react";
import tw from "src/utils/tw";

interface Props {
  includeClear?: boolean;
  disabled?: boolean;
  onClickClear?: (e) => void;
  onClick?: (e) => void;
  children?: ReactNode;
  className?: any;
  small?: boolean;
  innerRef?: Ref<any>;
  ref?: Ref<any>;
  round?: boolean;
}

function FilterButton(props: Props) {
  return (
    <div
      className={tw(
        "truncate rounded-full border border-b-3 border-borderGray bg-white text-organization transition hover:border-organization",
        props.disabled && "opacity-50 hover:cursor-default",
        props.small ? "h-9" : "h-11",
        !props.round && "float-right",
        props.round && "w-9",
        props.includeClear && "border-organization",
        props.className
      )}
    >
      <button
        onClick={props.onClick}
        className={tw(props.round && "w-full", props.className)}
        ref={props.innerRef}
        disabled={props.disabled}
      >
        <span
          className={tw(
            props.round && "w-full",
            "inline-block",
            props.round && "py-1",
            !props.round && "px-3 py-1"
          )}
        >
          {props.children}
        </span>
      </button>
      {props.includeClear && (
        <span
          onClick={props.onClickClear}
          className="inline-block cursor-pointer border-l border-l-borderGray py-1 pl-3 pr-4"
        >
          <i aria-hidden className="far fa-circle-xmark text-empty" />
        </span>
      )}
    </div>
  );
}

export default React.forwardRef((props: Props, ref) => (
  <FilterButton {...props} innerRef={ref} />
));
